import script from "./FilialCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./FilialCadastro.vue?vue&type=script&setup=true&lang=js"

import "./FilialCadastro.vue?vue&type=style&index=0&id=822cf55a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-822cf55a"]])

export default __exports__